import React, { useState } from 'react';
import { TrendingUp } from 'lucide-react';
import Statistics from './Statistics';
import PageHeader from './common/PageHeader';

const tabs = [
    { key: 'order', label: '주문 통계' },
    // { key: 'outsource', label: '외주 통계' },   // 10-30 대표: 옛 외주 데이터·화면 삭제
];

function StatisticsHub({ user }) {
    const [activeTab, setActiveTab] = useState('order');

    return (
        <div style={styles.container}>
            <PageHeader icon={TrendingUp} title="통계" />
            <div style={styles.tabBar}>
                {tabs.map(t => (
                    <button
                        key={t.key}
                        onClick={() => setActiveTab(t.key)}
                        style={{
                            ...styles.tab,
                            backgroundColor: activeTab === t.key ? '#6366f1' : '#f1f5f9',
                            color: activeTab === t.key ? '#fff' : '#64748b',
                        }}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
            <Statistics user={user} />
        </div>
    );
}

const styles = {
    container: { padding: '24px', maxWidth: 1200, margin: '0 auto' },
    tabBar: { display: 'flex', gap: 8, marginBottom: 20 },
    tab: {
        padding: '8px 16px', border: 'none', borderRadius: 8,
        fontSize: 13, fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s',
    },
};

export default StatisticsHub;
